module.exports = "https://www.gc-pro.gnp.com.mx/8391bd20e315089a82cd2b01e384fea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/questionIcon.svg
// module id = 8161
// module chunks = 0